import React from 'react';

function BuiltOnInnovationSection() {
  const styles = {
    section: {
      padding: '80px 48px', background: '#fff', textAlign: 'center',
      width: '100%', maxWidth: 1920, boxSizing: 'border-box'
    },
    subheading: {
      fontFamily: 'Lato', fontWeight: 400, fontSize: '26px', lineHeight: '100%',
      letterSpacing: '-0.01em', textTransform: 'uppercase', color: '#090909',
      margin: '0 0 16px 0'
    },
    accentLine: {
      width: 150, height: 0, borderTop: '2px solid #E73123', margin: '0 auto 24px auto'
    },
    titleWrap: { marginBottom: 24 },
    titleRed: {
      fontFamily: 'Lato', fontWeight: 700, fontSize: '40px', lineHeight: '100%',
      letterSpacing: 0, textTransform: 'uppercase', color: '#E73123', display: 'inline'
    },
    titleDark: {
      fontFamily: 'Lato', fontWeight: 700, fontSize: '40px', lineHeight: '100%',
      letterSpacing: 0, textTransform: 'uppercase', color: '#090909', display: 'inline',
    },
    description: {
      fontFamily: 'Lato', fontWeight: 400, fontSize: 16, lineHeight: '26px',
      letterSpacing: 0, color: '#838383', margin: '0 auto 48px auto', maxWidth: 900
    },
    cardsRow: {
      display: 'flex', gap: 24, flexWrap: 'nowrap', overflowX: 'auto',
      maxWidth: 1920, margin: '0 auto', width: '100%', paddingBottom: 16,
      scrollbarWidth: 'none', msOverflowStyle: 'none', scrollSnapType: 'x mandatory',
      WebkitOverflowScrolling: 'touch'
    },
    card: {
      width: 300, minWidth: 300, minHeight: 520, flexShrink: 0, background: '#FFFFFF', opacity: 1,
      overflow: 'visible', textAlign: 'center', boxSizing: 'border-box', padding: 0,
      display: 'flex', flexDirection: 'column',
      boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      cursor: 'pointer', scrollSnapAlign: 'start'
    },
    cardImg: {
      width: '100%', maxWidth: '100%', height: 'auto', objectFit: 'contain', objectPosition: 'center center',
      display: 'block', opacity: 1, verticalAlign: 'top', border: 0, outline: 'none',
      margin: 0, padding: 0, boxShadow: 'none', background: 'transparent', flexShrink: 0
    },
    cardContent: { padding: '20px 14px', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' },
    cardTitle: {
      fontFamily: 'Lato', fontWeight: 700, fontSize: '20px', lineHeight: '1.4',
      letterSpacing: 0, textTransform: 'uppercase', color: '#090909', margin: '0 0 10px 0'
    },
    cardDesc: {
      fontFamily: 'Lato', fontWeight: 400, fontSize: 16, lineHeight: '26px',
      letterSpacing: 0, color: '#838383', margin: 0
    }
  };

  const cards = [
    { img: '/projectmngmnt.png', title: 'PROJECT PLANNING &\nMANAGEMENT', desc: 'Efficient planning and disciplined execution for timely, cost-effective project delivery.' },
    { img: '/structengg.png', title: 'STRUCTURAL\nENGINEERING', desc: 'Engineering-driven solutions built for strength, stability, and lasting performance.' },
    { img: '/constructtech.png', title: 'CONSTRUCTION\nTECHNOLOGY', desc: 'Strategic planning with precise execution to deliver projects on time and within budget.' },
    { img: '/qualityassurance.png', title: 'QUALITY ASSURANCE &\nCONTROL', desc: 'Committed to maintaining rigorous quality standards and industry-leading safety standards without compromise.' },
    { img: '/health.png', title: 'HEALTH, SAFETY &\nENVIRONMENT (HSE)', desc: 'Strong safety standards and environmental responsibility across every project.' }
  ];

  return React.createElement(React.Fragment, null,
    React.createElement('style', null,
      '.innovation-card:hover { transform: translateY(-8px); box-shadow: 0 16px 40px rgba(0,0,0,0.18); }' +
      '.innovation-cards-row::-webkit-scrollbar { display: none; }' +
      '.innovation-card img { border: 0 !important; outline: none !important; box-shadow: none !important; }'
    ),
    React.createElement('section', { style: styles.section },
    React.createElement('h2', { style: styles.subheading }, 'BUILT ON INNOVATION'),
    React.createElement('div', { style: styles.accentLine }),
    React.createElement('div', { style: styles.titleWrap },
      React.createElement('span', { style: styles.titleRed }, 'ENGINEERING '),
      React.createElement('span', { style: styles.titleDark }, 'EXCELLENCE AT THE CORE')
    ),
    React.createElement('p', { style: styles.description },
      'We deliver accurate and dependable foundation solutions using advanced machinery and expert engineering to ensure structural stability in every project.'
    ),
    React.createElement('div', { className: 'innovation-cards-row', style: styles.cardsRow },
      cards.map(function(c, i) {
        return React.createElement('div', { key: i, className: 'innovation-card', style: styles.card },
          React.createElement('img', { src: c.img, alt: '', style: styles.cardImg }),
          React.createElement('div', { style: styles.cardContent },
            React.createElement('h3', { style: { ...styles.cardTitle, whiteSpace: 'pre-line' } }, c.title),
            React.createElement('p', { style: styles.cardDesc }, c.desc)
          )
        );
      })
    )
    )
  );
}

export default BuiltOnInnovationSection;
